module.exports = __webpack_public_path__ + "static/media/mittens-min.abe49dec.png";